import type { ContentLanguage } from "../components/SettingsControls"

/**
 * A bracketed stand-in such as "[Your name]" or "[E-Mail]". The org's email
 * signature and PDF footer ship with these until someone writes their own.
 * Same pattern the send gate refuses and the declaration renderer scrubs
 * (`PLACEHOLDER_TOKEN_RE` in backend/turnus_ai/mc_constants.py).
 */
const PLACEHOLDER = /\[[^\]\n]+\]/g

/** The placeholders still in `text`, each once, in order of appearance. */
export function placeholderTokens(text: string): string[] {
  return [...new Set(text.match(PLACEHOLDER) ?? [])]
}

/** The lines of `text` that still hold a placeholder, trimmed. */
export function placeholderLines(text: string): string[] {
  return text
    .split("\n")
    .filter((line) => new RegExp(PLACEHOLDER.source).test(line))
    .map((line) => line.trim())
}

/** A text the org still has to write: empty, or a placeholder left in it. */
export function needsWriting(text: string): boolean {
  return !text.trim() || placeholderTokens(text).length > 0
}

/** Which languages of a per-language text still need writing. */
export function languagesNeedingWriting(
  texts: Record<ContentLanguage, string>,
): Record<ContentLanguage, boolean> {
  return { en: needsWriting(texts.en), de: needsWriting(texts.de) }
}
